import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-video-dialog',
  templateUrl: './video-dialog.component.html',
  styleUrls: ['./video-dialog.component.css']
})
export class VideoDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<VideoDialogComponent>
  ) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/video-dialog/video-dialog.component.ts